export default "__VITE_ASSET__badbe55c__"